import React, { useState } from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { EditOutlined, DragOutlined, MoreOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'
import ImageViewModal from './ImageViewModal'

function InventoryItem(props) {
  const { el, setVisible, setActiveItem } = props
  const [imageModalVisible, setImageModalVisible] = useState(false)
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: el.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  // Handle data which might be a string or object
  const getImageSrc = () => {
    if (!el.data) return ''
    if (typeof el.data === 'string') {
      try {
        const parsed = JSON.parse(el.data)
        return parsed?.src || ''
      } catch {
        return ''
      }
    }
    return el.data?.src || ''
  }

  const imageSrc = getImageSrc()

  const handleEdit = () => {
    setActiveItem(el)
    setVisible(true)
  }

  const handleViewImage = () => {
    setImageModalVisible(true)
  }

  const handleAddBefore = () => {
    setActiveItem({
      actionType: 'add',
      inventoryType: el.inventoryType,
      xExperienceId: el.xExperienceId,
      insertPosition: 'before',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const handleAddAfter = () => {
    setActiveItem({
      actionType: 'add',
      inventoryType: el.inventoryType,
      xExperienceId: el.xExperienceId,
      insertPosition: 'after',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const menu = (
    <Menu>
      <Menu.Item key="addBefore" onClick={handleAddBefore}>
        Add Item Before
      </Menu.Item>
      <Menu.Item key="addAfter" onClick={handleAddAfter}>
        Add Item After
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="viewImage" onClick={handleViewImage}>
        Inspect Image
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        data-id={el.id}
        className="inventory-row"
      >
        <div className="inventory-row-drag-handle" {...listeners}>
          <DragOutlined />
        </div>
        <div className="inventory-row-thumbnail">
          <img alt={el.displayName || ''} src={imageSrc} />
        </div>
        <div className="inventory-row-content">
          <div className="inventory-row-display-name">
            {el.displayName || ''}
          </div>
          <div className="inventory-row-internal-name">
            {el.internalName || ''}
          </div>
        </div>
        <div className="inventory-row-actions">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={handleEdit}
            className="inventory-row-edit-btn"
          />
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="text"
              icon={<MoreOutlined />}
              className="inventory-row-more-btn"
            />
          </Dropdown>
        </div>
      </div>
      <ImageViewModal
        visible={imageModalVisible}
        imageSrc={imageSrc}
        onClose={() => setImageModalVisible(false)}
      />
    </>
  )
}
export default InventoryItem
